import React from 'react';
import { Link as LinkIcon, CreditCard, DollarSign, Wallet } from 'lucide-react';

const META = {
    stripe:   { label: 'Stripe',  color: '#635BFF', icon: CreditCard },
    square:   { label: 'Square',  color: '#000000', icon: CreditCard },
    venmo:    { label: 'Venmo',   color: '#3D95CE', icon: Wallet },
    cashapp:  { label: 'Cash App',color: '#00D54B', icon: DollarSign },
    zelle:    { label: 'Zelle',   color: '#6D1ED4', icon: DollarSign },
    other:    { label: 'Payment Link', color: '#1a3a5c', icon: LinkIcon },
};

export function PaymentProviderBadge({ provider, className = '' }) {
    const m = META[provider] || META.other;
    const Icon = m.icon;
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${className}`}
            style={{ borderColor: m.color + '55', color: m.color, background: m.color + '0F' }}
        >
            <Icon className="h-3 w-3" /> {m.label}
        </span>
    );
}
